import React from "react";
import commoncss from "../../../css/common.module.css";
import Modal from "../../../elements/Modal";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import MultipleFiles from "../../../assets/icons/MultipleFiles.png";
import MultipleSheets from "../../../assets/icons/MultipleSheets.png";

const PresetChoiceModal = ({ isOpen, onClose, onSelectExisting, onSelectNew }) => {
  if (!isOpen) return null;

  return (
    <Modal
      title="Save Preset"
      bodycss={commoncss.unsetPadding}
      width="530px"
      headerActions={
        <CloseIcon
          onClick={onClose}
          className="clickable"
          style={{ cursor: "pointer" }}
        />
      }
      onClose={onClose}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "16px",
          padding: "20px 24px 24px",
          fontFamily: "'DM Sans', sans-serif",
        }}
      >
        {/* Existing Preset Card */}
        <div
          style={{
            flex: 1,
            border: "1px solid #C2E6D1",
            borderRadius: "16px",
            cursor: "pointer",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            transition: "all 0.2s ease-in-out",
          }}
          onClick={() => {
            onClose();
            onSelectExisting();
          }}
        >
          <div
            style={{
              height: "170px",
              background: "#ffffff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={MultipleFiles}
              alt="Existing Preset"
              style={{ maxHeight: "95%", maxWidth: "95%", objectFit: "contain" }}
            />
          </div>
          <div
            style={{
              padding: "12px 16px",
              background: "#f4faf5",
              textAlign: "left",
              flexGrow: 1,
              borderTop: "1px solid #C2E6D1",
            }}
          >
            <div
              style={{
                fontSize: "17px",
                color: "#183930",
                marginBottom: "6px",
                fontWeight: 500,
              }}
            >
              Existing Preset
            </div>
            <div
              style={{
                fontSize: "13px",
                color: "#809790",
                lineHeight: "1.4",
              }}
            >
              Select from saved presets to update grouping
            </div>
          </div>
        </div>

        {/* New Preset Card */}
        <div
          style={{
            flex: 1,
            border: "1px solid #C2E6D1",
            borderRadius: "16px",
            cursor: "pointer",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            transition: "all 0.2s ease-in-out",
          }}
          onClick={() => {
            onClose();
            onSelectNew();
          }}
        >
          <div
            style={{
              height: "170px",
              background: "#ffffff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={MultipleSheets}
              alt="New Preset"
              style={{ maxHeight: "95%", maxWidth: "95%", objectFit: "contain" }}
            />
          </div>
          <div
            style={{
              padding: "12px 16px",
              background: "#f4faf5",
              textAlign: "left",
              flexGrow: 1,
              borderTop: "1px solid #C2E6D1",
            }}
          >
            <div
              style={{
                fontSize: "17px",
                color: "#183930",
                marginBottom: "4px",
                fontWeight: 500,
              }}
            >
              New Preset
            </div>
            <div
              style={{
                fontSize: "13px",
                color: "#809790",
                lineHeight: "1.4",
              }}
            >
              Create a new preset name for current mappings
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PresetChoiceModal;
